export default "__VITE_ASSET__SvzneL4t__"